import { HttpWorkflowService } from './../../../service/http-workflow.service';
import { Component } from '@angular/core';
import { WorkflowDto } from '../../../service/dto';
import { Router } from '@angular/router';

@Component({
	selector: 'app-workflow-list',
	standalone: false,
	templateUrl: './workflow-list.component.html',
	styleUrl: './workflow-list.component.scss'
})
export class WorkflowListComponent {
	data: WorkflowDto[] = [];
	constructor(private httpService: HttpWorkflowService, private router: Router) {
	}
	ngOnInit(): void {
		this.httpService.getAll().subscribe(result => this.data = result);
	}



	add() {
		this.router.navigate(['/workflow', 'new']);
	}
	viewWorkflow(input: WorkflowDto) {
		this.router.navigate(['/workflow', input.id]);
	}
	// hasDraft(input: WorkflowDto){
	// 	return localStorage.getItem(`workflow_draft_${(input.id??'new')}`) !== undefined;
	// }
}
